import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/departments/')({

}).lazy(() => import('./index.lazy').then((d) => d.Route));
